<template>
  <div class="chat-script-download-search-bar">
    <div class="date-wrap">
      <div class="date-item start-date">
        <InputDate v-model="form.startDate" :min-date="limitDateRange.start" :max-date="limitDateRange.end" />
      </div>
      <span>~</span>
      <div class="date-item end-date">
        <InputDate v-model="form.endDate" :min-date="form.startDate" :max-date="limitDateRange.end" />
      </div>
    </div>
    <button type="button" class="gray-btn auto-m-btn" @click="emit('search')">{{ t('label_search') }}</button>
    <div v-if="isDesktopOrTablet" class="filter-num">
      <p>
        {{ t('label_all') }} ・ {{ t('label_total') }} <span> {{ counts }} </span>{{ t('label_count_items') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import InputDate from '@/components/shared/base/InputDate.vue';
import { useDeviceSize } from '@/composables/shared/useDeviceSize';
import dayjs from '@/plugins/dayjs';
import { DateRange, ScriptDownloadSearchForm } from '@/types/components';

const form = defineModel<ScriptDownloadSearchForm>({
  default: () => ({
    chatType: 'GENERAL',
    code: '',
    startDate: '',
    endDate: '',
  }),
});

withDefaults(
  defineProps<{
    counts?: number;
  }>(),
  {
    counts: 0,
  }
);

const emit = defineEmits<{ search: [] }>();

const { t } = useI18n();
const { isDesktopOrTablet } = useDeviceSize();

const limitDateRange = computed<DateRange>(() => {
  return {
    start: dayjs().subtract(1, 'year').format('YYYY-MM-DD') + 'T00:00:00',
    end: dayjs().format('YYYY-MM-DD') + 'T23:59:59',
  };
});
</script>

<style scoped lang="scss">
.chat-script-download-search-bar {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: $size-s;

  .date-wrap {
    display: flex;
    align-items: center;
    gap: $size-s;

    .date-item {
      :deep(.date-picker) {
        min-height: 2.5rem;
        height: 2.5rem;
        font-size: $font-size-psmall;
      }
    }
  }
  .tb-gray-btn {
    background: var(--button-background-micinput-on);
    color: var(--font-default);
  }
  .auto-m-btn {
    height: 2.5rem;
    padding: 0 1rem;
    border-radius: 8px;
    font-size: $font-size-psmall;
    color: var(--font-default);
  }
  .auto-s-btn {
    height: 2rem;
    padding: 0 1rem;
    border-radius: 8px;
    color: var(--font-default);
  }

  .filter-num {
    padding-left: 1rem;
    p {
      font-size: $font-size-psmall;
      color: $color-gray-200;
      span {
        color: $color-gray-900;
      }
    }
  }
}

@media (max-width: 768px) {
  .chat-script-download-search-bar {
    .date-wrap {
      width: 100%;
      gap: 0.25rem;
      .date-item {
        width: 100%;
      }
    }
    .filter-num {
      margin-top: 0.5rem;
      background: #fafafb;
      padding: 0.5rem 0.75rem;
      border-radius: $size-s;
      p {
        font-size: $font-size-psmall;
        color: $color-gray-200;
        span {
          color: $color-gray-900;
        }
      }
    }
  }

  .date-item {
    &::before {
      right: 10px;
    }
    :deep(.date-picker) {
      padding: 0.5rem 2rem 0.5rem 0.75rem;
    }
  }

  .data-off {
    padding: 4rem 0;
  }
}
</style>
